import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { Service } from '#advertDetail/components';
import advertDetailCss from '../../assets/advert-detail.module.scss';
import advertDetailServiceListCss from '../../assets/service/service-list.module.scss';

const ServiceList: FC = () => {
  const {
    advert: {
      serviceDataList,
    },
  } = useAdvertDetailContext();

  if (serviceDataList.length === 0) {
    return null;
  }

  const serviceElementList = serviceDataList.map((serviceData) => (
    <Service key={serviceData.id} serviceData={serviceData} />
  ));

  return (
    <div
      className={classNames(
        advertDetailCss.advertDetail__serviceList,
        advertDetailServiceListCss.advertDetailServiceList,
      )}
    >
      <div className={advertDetailServiceListCss.advertDetailServiceList__header}>
        <FormattedMessage defaultMessage="Services:" />
      </div>
      <div className={advertDetailServiceListCss.advertDetailServiceList__list}>
        {serviceElementList}
      </div>
    </div>
  );
};

export { ServiceList };
